export enum DarksiteFormControl {
  COMPANION_NAME = 'companionName',
  EMAIL_ADDRESS = 'emailAddress',
  FIRST_NAME = 'firstName',
  HOME_ADDRESS = 'homeAddress',
  LAST_NAME = 'lastName',
  OTHER = 'relationOther',
  PHONE_NUMBER = 'phoneNumber',
  MOBILE_NUMBER = 'mobileNumber',
  PAX_DOB = 'paxDateOfBirth',
  PAX_FIRST_NAME = 'paxFirstName',
  PAX_HOME_ADDRESS = 'paxHomeAddress',
  PAX_LAST_NAME = 'paxLastName',
  PAX_NATIONALITY = 'paxNationality',
  RELATION = 'paxRelationship',
  RELATIVE = 'paxRelative',
  PHONE_PREFIX = 'phonePrefix',
}

export enum DOBFormControl {
  DAY = 'dateOfBirth',
  MONTH = 'monthOfBirth',
  YEAR = 'yearOfBirth',
}

export interface DarksiteForm {
  [DarksiteFormControl.RELATIVE]: string;
  [DarksiteFormControl.RELATION]: string;
  [DarksiteFormControl.OTHER]?: string;
  [DarksiteFormControl.FIRST_NAME]: string;
  [DarksiteFormControl.LAST_NAME]: string;
  [DarksiteFormControl.PAX_DOB]?: {
    [DOBFormControl.DAY]?: string;
    [DOBFormControl.MONTH]?: string;
    [DOBFormControl.YEAR]?: string;
  };
  [DOBFormControl.DAY]?: string;
  [DOBFormControl.MONTH]?: string;
  [DOBFormControl.YEAR]?: string;
  [DarksiteFormControl.PHONE_NUMBER]: string;
  [DarksiteFormControl.MOBILE_NUMBER]: string;
  [DarksiteFormControl.EMAIL_ADDRESS]?: string;
  [DarksiteFormControl.HOME_ADDRESS]?: string;
  [DarksiteFormControl.PAX_FIRST_NAME]: string;
  [DarksiteFormControl.PAX_LAST_NAME]: string;
  [DarksiteFormControl.PAX_NATIONALITY]?: string;
  [DarksiteFormControl.PAX_HOME_ADDRESS]?: string;
  [DarksiteFormControl.COMPANION_NAME]?: string;
}

export interface DarksiteFormData {
  family: string;
  relation: string;
  contact: {
    firstName: string;
    lastName: string;
    phoneNumber: string;
    mobileNumber: string;
    emailAddress?: string;
    homeAddress?: string;
  };
  passenger: {
    firstName: string;
    lastName: string;
    dateOfBirth?: string;
    nationality?: string;
    homeAddress?: string;
  };
  companionTraveller?: string;
}

export enum RelativeQuestion {
  NO = 'paxRelativeNo',
  YES = 'paxRelativeYes',
}

export enum RelationQuestion {
  BROTHER = 'brother',
  DAUGHTER = 'daughter',
  FATHER = 'father',
  MOTHER = 'mother',
  OTHER = 'other',
  SISTER = 'sister',
  SON = 'son',
  SPOUSE = 'spouse',
}

export const DARKSITE_GTMCONTEXT = 'inccident-updates-form';
export const PHONE_NUMBER_PATTERN = '^\\+[0-9\\s]{1,15}$';
export const PHONE_NUMBER_NO_SPACES_PATTERN = '^\\+[0-9]{1,15}$';
